// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","image":"Image_image__6apiO","image-error":"Image_image-error__6KYFr"};